export interface ClaimTypeSelected {
  ClaimTypeID: string;
  ClaimTypeCode?: string;
  ApplianceUseable?: boolean;
}
